export default {
  en: {
    'scouting_youth_player_completed': '{player} youth player scouted.',
    'scouting_completed': 'Scouting completed!',
    'negotiation_started': 'Negotiation started!',
    'your_are_only_allowed_to_recruit_limit_amount_per_season': 'Your are only allowed to recruit a limited amount per season',
    'no_youth_players_scouted_yet': 'No youth players scouted yet!',
    'scouted': 'scouted',
    'new_youth_player_revealed': 'New youth player revealed!',
    'region_x': 'region: {name}',
    'select_scout_for_region': 'select scout for region: {name}',
    'select_scout_for_youth_player': 'select scout for youth player: {name}',
    'selected': 'selected',
    'unselected': 'unselected',
    'newcomers_selection_limit': 'newcomers selection limit: {count}/{limit}',
    'newcomers': 'newcomers',
    'select_players': 'select players ({count})',
    'limit_of_player_count_reached': 'limit of player count reached',
    '': '',
  }
};